import { render, staticRenderFns } from "./ProviderCell.vue?vue&type=template&id=5b339a7b&scoped=true&"
import script from "./ProviderCell.vue?vue&type=script&lang=js&"
export * from "./ProviderCell.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCell.vue?vue&type=style&index=0&id=5b339a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b339a7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDivider,VIcon,VTooltip})
